'use strict';
import $ from 'jquery';

export default class DefaultMarketoForm {
    constructor() {
        if ($('.default-marketo-form').length > 0) {
            $('.default-marketo-form').each((i, form) => {
                $(form).on('submitSuccess', () => {
                    console.log("default form submitted");
                    $(form).addClass('completed');
                    $(form).siblings('.form-title').hide();
                    if ($(form).data('redirect-url')) {
                        setTimeout(() => {
                            document.location.href = decodeURIComponent($(form).data('redirect-url').replace(/\+/g, ' '));
                        }, 500);
                    }
                    return false;
                });
            });
        }
    }
}